import styled from 'styled-components'

const LoadsListWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
`
LoadsListWrapper.displayName = 'LoadsListWrapper'
export default LoadsListWrapper
